import { render, staticRenderFns } from "./ProjectPreview.vue?vue&type=template&id=1f71f8a0&"
import script from "./ProjectPreview.vue?vue&type=script&lang=js&"
export * from "./ProjectPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports